/** *
 * 处方发货及订单管理
 */
import Main from '@components/main/main'

const prescriptionDrug = {
  path: '/prescriptionDrug',
  component: Main,
  redirect: '/prescriptionDrug/presDeliveryList',
  children: [{
    name: 'presDeliveryList',
    path: '/prescriptionDrug/presDeliveryList',
    component: () => import ('@pages/prescriptionDrug/pages/presDelivery/list'),
    meta: {
      auth: true,
      title: '订单管理'
    }
  }, {
    name: 'presDeliveryDetail',
    path: '/prescriptionDrug/presDeliveryDetail',
    component: () => import ('@pages/prescriptionDrug/pages/presDelivery/details'),
    meta: {
      auth: true,
      title: '订单管理'
    }
  }, {
    name: 'prescribeList',
    path: '/prescriptionDrug/prescribeList',
    component: () => import ('@pages/prescriptionDrug/pages/prescribe/list'),
    meta: {
      auth: true,
      title: '处方订单管理'
    }
  }, {
    name: 'prescribeDetail',
    path: '/prescriptionDrug/prescribeDetail',
    component: () => import ('@pages/prescriptionDrug/pages/prescribe/details'),
    meta: {
      auth: true,
      title: '处方订单详情'
    }
  }]
}

export default prescriptionDrug



// WEBPACK FOOTER //
// ./src/pages/prescriptionDrug/index.js